import { Component, OnInit, ViewChild, Input, OnDestroy, AfterViewInit } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { NavigationService } from "app/core/services/navigation.service";
import { ToastService } from "app/core/services/toast.service";
import { NotlistService } from "app/modules/admin/notification-list/services/notlist.service";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { AppLoaderService } from "../app-loader/app-loader.service";

export interface List {
  notification_id: number;
  title: string;
  body: string;
  user_type: number;
  page: string;
  portal: string;
  data: {
    admin_notification_id: number;
    customer_id: number;
    category_id: number;
    type_of_user: number;
    whom_to_send: number;
    message: string;
    page: string;
    random_id: string;
  };
  msg_read: number;
  created_on: string;
  status: string;
}
@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
})
export class NotificationsComponent implements OnInit,OnDestroy,AfterViewInit{
  @Input() notificPanel;
notificationCall:Subscription;
  // Dummy notifications
 @Input() notifications: List[] = [];

  constructor(private router: Router, private service: NotlistService,
    private navService : NavigationService,
    private activatedRoute : ActivatedRoute) {}

  ngOnInit() {
    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel.close();
        if(localStorage.getItem('OGJWTTOKEN')!=null){
          // this.notificationList();
          this.activatedRoute.queryParams.subscribe((res:any)=>{
            if(res?.notId!=undefined){
              this.notifications=this.notifications.filter(ele=>ele?.data?.random_id!=res?.notId)
            }
          })
        }
      }
    });

  }

  clearAll(e) {
    e.preventDefault();
    this.notifications = [];
  }
  ngAfterViewInit(): void {

  }

  // get notificatiolist

  notificationList() {
   this.service.getAllnotification("").subscribe((res: any) => {
    ////console.log('hitting ');
    
      if (res?.keyword == "success") {
        let data: List[] = res?.data;
        this.notifications = data.filter((ele) => Number(ele?.msg_read) == 0);
        this.navService.notificationCount.next(this.notifications?.length)
      }else{
        // this.notificationCall.unsubscribe(); 
      }
    });
  }

  changeTime(data: any) {
    return moment(data).fromNow();
  }

  changeStatus(ele: any) {
    if (ele?.msg_read == 0) {
      let formData = new FormData();
      formData.append("id", JSON.stringify([ele?.notification_id]));
      this.service.readNotification(formData).subscribe((res: any) => {
        if (res?.keyword == "success") {
          this.notificationList();
          switch (ele?.page) {
            // adsmanagent redirection
            case "ads_management":
              this.router.navigate(["/ads-management/view"], {
                queryParams: { adsId: ele?.data?.ads_id },
              });
              break;
            // payment transaction redirection 
            case "payment_transaction":
              this.router.navigate([`/payment-transaction`]);
              break;
            // usermanagement redirection

            case "user_management":
              this.router.navigate([`/user-management/view`], {
                queryParams: { userId: ele?.data?.customer_id },
              });
              break;

            // feedback redirection
            case "feedback":
              this.router.navigate([`/feedback`]);
              break;
            default:
              break;
          }
          this.notificPanel.close()
         
        } else {
          //  this.loader.close();
          //  this.toaster.showWarningToast(res?.message)
        }
      });
    }
  }

  ngOnDestroy(): void {
    // this.notificationCall.unsubscribe()
  }
}
